

export const getDownloadAllUserAcc = async (setDownloadAllUserAcc) => {
    var endpoint = '/admin/users/download/all.json';
    try{
        const res = await fetch( process.env.REACT_APP_API_HOST + endpoint, {
            method: 'GET'
        });
        res.json().then((res) => {
            setDownloadAllUserAcc(res.data)
        });
        if(!res.ok){
            throw new Error(`Error ${res.status}: ${res.statusText}`);
        }
    }catch(err) {

    }
}

export const getDownloadUserAcc = async (userId,setDownloadUserAcc) => {
    var endpoint = '/admin/users/download/'+userId+'/user.json';
    try{
        const res = await fetch( process.env.REACT_APP_API_HOST + endpoint, {
            method: 'GET'
        });
        res.json().then((res) => {
            setDownloadUserAcc(res.data)
        });
        if(!res.ok){
            throw new Error(`Error ${res.status}: ${res.statusText}`);
        }
    }catch(err) {

    }
}

export const updateUserAcc = async (userAcc) => {
    var endpoint = '/admin/users/download/'+userAcc.id+'/user.json';
    try {
        const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(userAcc),
        })
        .then((res) => {
            alert ("Account" + userAcc.id + "has been updated successfully.");
        })
        .then((data) => {});
        if (!res.ok) {
            throw new Error(`Error ${res.status}: ${res.statusText}`);
          }
    } catch (err) {}
};

export const deleteUserAcc = async (userAcc) => {
    var endpoint = 'admin/users/download/'+ userAcc.id +'/user.json';
    try{
        const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
            method: 'DELETE',
        }).then((res) => {
            alert( "Account" + userAcc.id + "has been successfully deleted.")
        });
        if(!res.ok){
            throw new Error(`Error ${res.status}: ${res.statusText}`)
        }
    }catch(err){}
}

export const getRoles = async(id, setRoles) => {
    var endpoint = '/admin/users/download/roles.json';
    try{
        const res = await fetch( process.env.REACT_APP_API_HOST + endpoint, {
            method: 'GET',
        });
        res.json().then((res) => {
            setRoles(res.data)
        });
        if (!res.ok) {
            throw new Error(`Error ${res.status}: ${res.statusText}`);
          }
    } catch (err) {}
}